import { types } from "../action-types";

const initialState = {
    loading: false,
    loadingAbout: false,
    details: [],
    error: false,
    dropdown: [],
    success: false,

};

const getCompanyDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_COMPANY_DETAILS_REQUESTED:
            return {
                ...state,
                loading: true,
                success: false,
            };

        case types.GET_COMPANY_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                dropdown: action.payload,
                error: false,
            };
        case types.GET_COMPANY_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                dropdown: [],
                error: true,
            };
        case types.POST_COMPANY_DETAILS_REQUESTED: 
            return {
                ...state,
                loading: true,
                loadingAbout: true,
                success: false,
            };
        case types.POST_COMPANY_DETAILS_SUCCESS:
            localStorage.setItem('userProfile', JSON.stringify(action.payload));
            return {
                ...state,
                details: action.payload,
                error: false,
                success: true,
                loadingAbout: false,
                // loading: false,
            }
        case types.POST_COMPANY_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                loadingAbout: false,
                details: [],
                error: true,
                success: false,
            }
        case types.POST_COMPANY_DETAILS_RESET:
            return {
                ...state,
                details: [],
                loading: false,
                loadingAbout: false,
                success: false,
            }
        case types.POST_TALENT_DETAILS_RESET:
            return {
                ...state,
                details: [],
                loading: true,
                success: false,
            }
        default:
            return state;
    }
};

export default getCompanyDetailsReducer;
